// extracted by mini-css-extract-plugin
module.exports = {"app__body":"app_app__body__Rfjhg"};